import PieBase from './PieBase';

const IS_MINOR = 'isMinor';
const MINOR = 'Minor';
const ADULT = 'Adult';

export default function AgeChart({ chartData }) {
  const data = [];
  const ageCounts = {};

  for (const alertElement of chartData) {
    const { indicators } = alertElement;
    for (const [program, isSelected] of Object.entries(indicators)) {
      if (program === IS_MINOR) {
        const age = isSelected ? MINOR : ADULT;
        if (!(age in ageCounts)) {
          ageCounts[age] = {
            label: age,
            value: 1,
          };
        } else {
          ageCounts[age].value += 1;
        }
      }
    }
  }

  for (const age of Object.values(ageCounts)) {
    data.push(age);
  }

  return (
    <PieBase
      title={'Ages'}
      data={data}
    />
  );
}
